
import { Footer } from "@/components/Footer";
import { Header } from "@/components/Header";

export default function Statuts() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 container mx-auto px-4 py-12">
        <h1 className="text-3xl md:text-4xl font-bold text-[#00123A] mb-8">Statuts</h1>
        <div className="prose max-w-none">
          <p className="text-lg mb-6">
            Les statuts de l'association Enfants de la République seront bientôt disponibles sur cette page.
          </p>
          <p className="text-lg mb-6">
            Pour toute question concernant les statuts de notre association, veuillez nous contacter à l'adresse suivante : contact@ledlr.org
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
